import React from 'react'

import { IGraphRowProps } from './interface'
import { GRAPH_ROW_TYPES } from 'app/constants/sprints'
import './styles.scss'
export const bc = 'graph-row'

const GraphRow = ({ actions, goal, avatar, type, t }: IGraphRowProps) => {
  const actionsLeft = actions >= goal ? 0 : goal - actions
  const actionBarWidth = actions >= goal ? 100 : (actions / goal) * 100
  const message =
    actions >= goal
      ? type === GRAPH_ROW_TYPES.USER
        ? 'Done. Great Job!'
        : 'We did it!'
      : `${type === GRAPH_ROW_TYPES.USER ? 'You' : 'We'} have ${actionsLeft}${
          type === GRAPH_ROW_TYPES.ORG ? ' more' : ''
        } to go`

  return (
    <div className={`${bc}__wrapper`}>
      <div className={`${bc}__graph-avatar`}>{avatar}</div>
      <div className={`${bc}__graph-and-actions`}>
        <div className={`${bc}__graph-background`}>
          <div className={`${bc}__graph`} style={{ width: `${actionBarWidth}%` }} />
        </div>
        <div className={`${bc}__actions`}>{t(message)}</div>
      </div>
    </div>
  )
}

export default GraphRow as React.FunctionComponent<IGraphRowProps>
